import { createContext } from 'react';
import { IFunctionalContext, IPurchaseContext } from '~/purchase/types';
export const FunctionalContext = createContext<IFunctionalContext | undefined>(
  undefined,
);
export const PurchaseContext = createContext<IPurchaseContext | undefined>(
  undefined,
);
